import { Aroon as defaultOptions } from "./defaultOptionsForComputation";

export default function () {
  let options = defaultOptions;

  function calculator(data) {
    const { period } = options;

    // Result array with same length as input
    const results = [];

    // State tracking
    let daysSinceHigh = 0;
    let daysSinceLow = 0;
    let xDayHigh = null;
    let xDayLow = null;

    for (let i = 0; i < data.length; i++) {
      const currentBar = data[i];

      if (
        !currentBar ||
        currentBar.high === undefined ||
        currentBar.low === undefined
      ) {
        results.push(undefined);
        continue;
      }

      // Initialize on first valid bar
      if (xDayHigh === null) xDayHigh = currentBar.high;
      if (xDayLow === null) xDayLow = currentBar.low;

      // Update highest high
      xDayHigh = Math.max(xDayHigh, currentBar.high);
      if (xDayHigh === currentBar.high) {
        daysSinceHigh = 0;
      } else {
        daysSinceHigh++;
        // If daysSince exceeds period, recalculate by looking back
        if (daysSinceHigh > period) {
          xDayHigh = currentBar.high;
          daysSinceHigh = 0;
          for (let j = 1; j <= period; j++) {
            if (i - j < 0) break;
            const prevBar = data[i - j];
            if (prevBar && prevBar.high !== undefined) {
              xDayHigh = Math.max(xDayHigh, prevBar.high);
              if (xDayHigh === prevBar.high) {
                daysSinceHigh = j;
              }
            }
          }
        }
      }

      // Update lowest low
      xDayLow = Math.min(xDayLow, currentBar.low);
      if (xDayLow === currentBar.low) {
        daysSinceLow = 0;
      } else {
        daysSinceLow++;
        // If daysSince exceeds period, recalculate by looking back
        if (daysSinceLow > period) {
          xDayLow = currentBar.low;
          daysSinceLow = 0;
          for (let j = 1; j <= period; j++) {
            if (i - j < 0) break;
            const prevBar = data[i - j];
            if (prevBar && prevBar.low !== undefined) {
              xDayLow = Math.min(xDayLow, prevBar.low);
              if (xDayLow === prevBar.low) {
                daysSinceLow = j;
              }
            }
          }
        }
      }

      // Calculate Aroon Up and Aroon Down
      // Aroon Up = 100 * (period - daysSinceHigh) / period
      // Aroon Down = 100 * (period - daysSinceLow) / period
      const aroonUp = 100 * (1 - daysSinceHigh / period);
      const aroonDown = 100 * (1 - daysSinceLow / period);

      results.push({
        aroonUp,
        aroonDown,
      });
    }

    return results;
  }

  calculator.undefinedLength = function () {
    return 0; // Aroon can start calculating from first bar
  };

  calculator.options = function (x) {
    if (!arguments.length) {
      return options;
    }
    options = { ...defaultOptions, ...x };
    return calculator;
  };

  return calculator;
}
